export default __webpack_public_path__ + "static/media/kitchen3-afterF-768w.4ec93921.png";